import CommonTNTBillingBase from '../../../util/CommonTNTBillingBase';

class ContractTypeBaseController extends CommonTNTBillingBase {
    /*@ngInject*/
    constructor(Auth, $state, User, Service, Modal, $translate, $stateParams) {

        super(Auth, $state, User, Service, Modal, $translate, $stateParams)

        this.errors = {};
        this.loading = false;
        this.errorMessage = '';
        this.model = {};
        this.toggleSwitchUI = {
            size: 'small',
            label: {
                on: 'Yes',
                off: 'No'
            },
            onColor: 'success',
            offColor: 'danger'
        }
    }

    askCreate() {
        return new Promise((resolve, reject) => {
            this.Modal.confirm({
                header: this.$translate.instant('contractType.create_another_title'),
                message: this.$translate.instant('contractType.create_another_message'),
                callback: ({
                    modal,
                    $scope
                }) => {
                    this.reset();
                    modal.close();
                    resolve(true);
                },
                negative: ({
                    modal,
                    $scope
                }) => {
                    modal.close();
                    window.history.go(-1);
                    resolve(false);
                },
                type: 'primary',
                buttons: ['common.yes', 'common.no']
            })
        })
    }

    validate() {
        this.clearErrors()
        for (let key in this.model) {
            if (!this.model[key]) {
                this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + 'is mandatory')
            }
        }
        return Object.keys(this.errors).length <= 0;
    }

    clearErrors() {
        this.errors = {};
        this.errorMessage = '';
    }

    addError(id, message) {
        this.errors[id] = message;
    }
}

export default ContractTypeBaseController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract_type/common/contract_type.base.controller.js